import { render, staticRenderFns } from "./IPQCAdminData.vue?vue&type=template&id=28ed8fb0&scoped=true"
import script from "./IPQCAdminData.vue?vue&type=script&lang=js"
export * from "./IPQCAdminData.vue?vue&type=script&lang=js"
import style0 from "./IPQCAdminData.vue?vue&type=style&index=0&id=28ed8fb0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ed8fb0",
  null
  
)

export default component.exports